<!-- <nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="POC Details"
  [nzMaskClosable]="false"
  (nzOnCancel)="handleCancel()"
  [nzFooter]="modalFooter"
>
  <ng-container *nzModalContent>
    <div class="venue-poc-modal-content">
      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Name:</div>
        <div class="venue-poc-value">{{ data?.name }}</div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Email:</div>
        <div class="venue-poc-value">{{ data?.email }}</div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Mobile:</div>
        <div class="venue-poc-value">
          {{ data?.country_code_details?.code }}
          {{ data?.mobile_number }}
        </div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Whatsapp:</div>
        <div class="venue-poc-value">
          {{ data?.country_code_details?.code }}
          {{ data?.whatsapp_number }}
        </div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Business:</div>
        <div class="venue-poc-value">
          {{ data?.country_code_details?.code }}
          {{ data?.business_number }}
        </div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Type:</div>
        <div class="venue-poc-value">
          {{ data?.is_primary ? "Primary" : "Secondary" }}
        </div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Created By:</div>
        <div class="venue-poc-value">{{ data?.created_by_name }}</div>
      </div>

      <div class="venue-poc-info-row">
        <div class="venue-poc-label">Created At:</div>
        <div class="venue-poc-value">
          {{ data?.created_at | date : "mediumDate" }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Close</button>
  </ng-template>
</nz-modal> -->
<nz-modal [(nzVisible)]="isVisible" nzTitle="POC Details" [nzMaskClosable]="false" (nzOnCancel)="handleCancel()"
  [nzFooter]="modalFooter">
  <ng-container *nzModalContent>
    <nz-descriptions nzBordered [nzColumn]="1" class="venue-poc-descriptions">
      <nz-descriptions-item nzTitle="Name">
        {{ data?.name }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Email">
        {{ data?.email }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Mobile">
        {{ data?.country_code_details?.code }}
        {{ data?.mobile_number }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Whatsapp">
        {{ data?.country_code_details?.code }}
        {{ data?.whatsapp_number }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Business">
        {{ data?.country_code_details?.code }}
        {{ data?.business_number }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Type">
        {{ data?.is_primary ? "Primary" : "Secondary" }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Created By">
        {{ data?.created_by_name }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Created At">
        {{ data?.created_at | date : "mediumDate" }}
      </nz-descriptions-item>
    </nz-descriptions>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Close</button>
  </ng-template>
</nz-modal>
